import { defineMessages } from 'react-intl';

export const DOMAIN_NAME = 'simstream' as const;

export const ActionKeys = Object.freeze({
  CHECK_STREAM_VIOLATION: 'CHECK_STREAM_VIOLATION',
  CLEAR_STREAM_VIOLATION: 'CLEAR_STREAM_VIOLATION',
  CREATE_STREAM_VIOLATION: 'CREATE_STREAM_VIOLATION',
  LET_ME_LISTEN: 'LET_ME_LISTEN',
  LET_THEM_LISTEN: 'LET_THEM_LISTEN',
  UPDATE_STREAM_VIOLATION_IS_STALE: 'UPDATE_STREAM_VIOLATION_IS_STALE',
} as const);

export const ReducerKeys = Object.freeze({
  // metadata returned by the server with regards to STREAM_VIOLATION
  ERROR_DATA: 'ERROR_DATA',
  IS_STALE: 'IS_STALE',
  STREAM_VIOLATION_DATA: 'STREAM_VIOLATION_DATA',
} as const);

export const StreamViolationDefaults = Object.freeze({
  AUTO_DEVICE_IMAGE_ID: 4,
  DIALOGUE_DELAY: 15, // seconds
  EXPIRES_IN: 30, // seconds
  GENERIC_DEVICE_IMAGE_ID: 0,
  PC_DEVICE_IMAGE_ID: 3,
  PHONE_DEVICE_IMAGE_ID: 1,
  TABLET_DEVICE_IMAGE_ID: 2,
  TV_DEVICE_IMAGE_ID: 5,
} as const);

export const Messages = defineMessages({
  simStreamModalTitle: {
    id: 't.simStreamModalTitle',
    defaultMessage: 'Pandora is currently playing on another device',
  },
  simStreamModalSubTitle: {
    id: 't.simStreamModalSubTitle',
    defaultMessage: 'Listen here instead?',
  },
  simStreamModalAcceptButtonText: {
    id: 't.simStreamModalAcceptButtonText',
    defaultMessage: 'Let Me Listen',
  },
  simStreamModalRejectButtonText: {
    id: 't.simStreamModalRejectButtonText',
    defaultMessage: 'Let Them Listen',
  },
});
